/*
 *                     NOTICE
 *            COPYRIGHT 2021 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { AbBooleanLogicGroupingContent } from "abreact/incubator/ui/abBooleanLogicTree/model/AbBooleanLogicGroupingContent";
import { AbBooleanLogicSingleConditionContent } from "abreact/incubator/ui/abBooleanLogicTree/model/AbBooleanLogicSingleConditionContent";
import { Record } from "immutable";
const AbBooleanLogicTreeContentDefaults = {
  nestingState: null // definitely assigned in ctor
};
export class AbBooleanLogicTreeContent extends Record(AbBooleanLogicTreeContentDefaults) {
  constructor(nestingState) {
    nestingState = nestingState ?? new AbBooleanLogicGroupingContent("rootGroupKey", "AND");
    super({
      nestingState
    });
  }
  /**
   * Utility method for visiting all the conditions, in no particular order
   */
  visitAllConditions(visit) {
    this.visitAllNodes(node => {
      if (node.cardinality === "SINGLE") {
        visit(node.key);
      }
    });
  }

  /**
   * Utility method for visiting all the groups, in no particular order
   */
  visitAllGroups(visit) {
    this.visitAllNodes(node => {
      if (node.cardinality === "GROUP") {
        visit(node.key);
      }
    });
  }

  /**
   * Recursively visit all the nodes in the logic tree.
   */
  visitAllNodes(visit) {
    this.nestingState.visitAllNodes(visit);
  }

  // helper method for strong typing
  with(values) {
    return this.merge(values);
  }

  /**
   *
   */
  appendRowToTopLevel(rowKey) {
    return this.with({
      nestingState: this.nestingState.withAppendSingleRow(new AbBooleanLogicSingleConditionContent(rowKey))
    });
  }

  /**
   *
   */
  clearAll() {
    return new AbBooleanLogicTreeContent();
  }
  findConditionRow(rowKey) {
    return this.nestingState.findRowLocation(rowKey);
  }
  findRowOrGroupLocation(key) {
    return this.nestingState.findRowOrGroupLocation(key);
  }
}
//# sourceMappingURL=AbBooleanLogicTreeContent.js.map
